import React, { useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import HomeButton from '../../components/HomeButton'
import CrossButton from '../../components/CrossButton'
import PropTypes from 'prop-types'

const Wrapper = styled.div`
  padding: 50px;
  border-top: 1px solid var(--clr-grey-6-to-white);

  .filter {
    padding-bottom: 20px;
  }

  .filter ul {
    max-height: none;
  }

  .filter h2 {
    font-weight: bold;
  }

  .filter label {
    font-weight: normal;
    font-size: 14px;
  }

  .filter label::before {
    width: 19px;
  }

  .filter input {
    height: 32px;
    border: 1px solid var(--clr-accent);
    border-radius: var(--border-radius);
    background: var(--white);
  }

  @media (max-width: 768px) {
    padding: 20px 0;
    border-top: none;
    min-height: calc(100vh - var(--header-height) - var(--search-input-height));
  }
`

const Button = styled(HomeButton)`
  margin: 5px auto 10px;
  width: 80%;
`

const ESSearch = ({ filters, results }) => {
  const [showFiltersMobile, setShowFiltersMobile] = useState(false)
  const toggleMobileFilters = () => setShowFiltersMobile(!showFiltersMobile)
  const filtersClassName = showFiltersMobile ? '' : 'hidden-xs'

  return (
    <Wrapper>
      <Row>
        <Col className={filtersClassName} sm={3}>
          <div className="clearfix visible-xs">
            <div className="pull-right">
              <CrossButton
                onClick={toggleMobileFilters}
                title="Close filters"
              />
            </div>
          </div>
          {filters}
        </Col>
        <Col sm={9}>
          <Button onClick={toggleMobileFilters} className="visible-xs">
            Filters <FontAwesomeIcon icon={faFilter} />
          </Button>
          {results}
        </Col>
      </Row>
    </Wrapper>
  )
}

ESSearch.propTypes = {
  filters: PropTypes.element.isRequired,
  results: PropTypes.element.isRequired
}

export default ESSearch



// WEBPACK FOOTER //
// ./src/components/ESSearch/index.js